import React, { useEffect, useState } from 'react';
import { Container } from '../ui/Container';
export function SocialProofStats() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setIsVisible(true);
  }, []);
  const stats = [{
    label: 'Business Cards Printed',
    value: '10,000+',
    delay: '0ms'
  }, {
    label: 'Happy Customers',
    value: '500+',
    delay: '100ms'
  }, {
    label: 'Delivery Coverage',
    value: '100%',
    sub: 'Australia-Wide',
    delay: '200ms'
  }, {
    label: 'Quote Turnaround',
    value: 'Same Day',
    delay: '300ms'
  }];
  return <div className="bg-gradient-to-r from-cyan-600 to-magenta-600 py-12 relative overflow-hidden" data-id="element-355">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-356"></div>

      <Container className="relative z-10" data-id="element-357">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-358">
          {stats.map((stat, index) => <div key={index} className={`transform transition-all duration-700 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{
          transitionDelay: stat.delay
        }} data-id="element-359">
              <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2 drop-shadow-md" data-id="element-360">
                {stat.value}
              </div>
              <div className="text-cyan-100 font-medium text-sm md:text-base uppercase tracking-wider" data-id="element-361">
                {stat.label}
              </div>
              {stat.sub && <div className="text-yellow-300 text-xs font-bold mt-1" data-id="element-362">
                  {stat.sub}
                </div>}
            </div>)}
        </div>
      </Container>
    </div>;
}